import React, { ReactNode, useEffect, useRef } from 'react'
import { Aside } from "../../aside/Aside";
import {
    TransitionGroup,
    CSSTransition
} from "react-transition-group";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { WrapperStyled } from "../Wrapper.styled";
import { useGlobalContext } from '../../../GlobalContext';

interface IWrapperSidebarProps {
    children: ReactNode
}

export const WrapperSidebar: React.FC<IWrapperSidebarProps> = ({children}) => {

    const location = useLocation(), { setScrollY } = useGlobalContext();

    const scrollableNodeRef = React.createRef<HTMLElement>();
    const nodeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = scrollableNodeRef.current;
        if(container) {
            container.onscroll = () => {
                setScrollY(container.scrollTop);
            };
        }
    }, [scrollableNodeRef, setScrollY]);

    useEffect(() => {
        function scroll() {
            setScrollY(window.scrollY);
        }
        window.addEventListener('scroll', scroll);
        scroll();
    },[setScrollY]);

    return (
        <WrapperStyled className="wrapper">
            <Aside/>

            <TransitionGroup component={null}>
                <CSSTransition key={location.pathname} classNames="fade" timeout={300} nodeRef={nodeRef}>

                    <div ref={nodeRef}>
                        <SimpleBar style={{paddingBottom: 0}} className="main" scrollableNodeProps={{ ref: scrollableNodeRef }}>

                            <div className="main__inner">
                                {children}
                            </div>

                        </SimpleBar>
                    </div>

                </CSSTransition>
            </TransitionGroup>

        </WrapperStyled>
    )
}
